import React from 'react'
import BlurText from "../BlurText/BlurText";


function Iniciosolucioines() {
  return (
    <div className='hero' id='soluciones'>
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster="/media/soluciones-hero.jpg"
        className="hero__video"
      >
        <source src="/media/soluciones-hero.mp4" type="video/mp4" />
      </video>

      <div className="hero__overlay" />
      <div className="hero__grain" />

      <div className="hero__content hero__content--fade">
        <h1 className="hero__title hero__title--blur">
          <BlurText
            text="SOLUCIONES GEOESPACIALES"
            delay={120}
            animateBy="words"
            direction="top"
            className="hero__blur"
          />
        </h1>
      </div>

      <div className="hero__scroll">
        <span className="hero__scrollLabel">SCROLL</span>
        <span className="hero__scrollLine" />
      </div>
    </div>
  )
}

export default Iniciosolucioines
